import { Box } from "@mui/material";
import FabPositioned from "../FabPositioned/FabPositioned";
import {
    RefreshContentFab,
    RefreshContentTypography,
} from "./RefreshContentButton.styles";
import { ArrowRotateRightIcon } from "@icons/ArrowRotateRightIcon";
import React, { RefObject, useEffect, useRef, useState } from "react";
import { useIsScrollingUp } from "@infrastructure/Hooks/useIsScrollingUp";
import { useInView } from "@infrastructure/Hooks/useInView";
import { isPlatformTippspiel } from "@infrastructure/Services/EnvService";

const TIME_TO_ENABLE_REFRESH_BUTTON = 5000;

export function RefreshContentButton({
    onClick,
    scrollableContainerRef,
    scrollToRef,
    isInsideModal = false,
}: {
    isInsideModal: boolean;
    onClick: () => void;
    scrollToRef?: RefObject<HTMLDivElement>;
    scrollableContainerRef?: RefObject<HTMLDivElement>;
}) {
    const [refreshContentFabButton, setRefreshContentFabButton] =
        useState(false);
    const [timeoutIsDone, setTimeoutIsDone] = useState(false);
    const comparisonToControllVisibilityRef = useRef<HTMLDivElement>();
    const isScrollingUp = useIsScrollingUp(scrollableContainerRef);

    useEffect(() => {
        const timeout = setTimeout(() => {
            setTimeoutIsDone(true);
        }, TIME_TO_ENABLE_REFRESH_BUTTON);

        return () => {
            clearTimeout(timeout);
        };
    }, []);
    const { ref, inView } = useInView();
    useEffect(() => {
        if (
            inView ||
            !isScrollingUp ||
            !timeoutIsDone ||
            !comparisonToControllVisibilityRef.current
        ) {
            setRefreshContentFabButton(false);
        } else {
            let isWindowBelowStartOfContainer;
            if (scrollableContainerRef?.current) {
                isWindowBelowStartOfContainer =
                    comparisonToControllVisibilityRef.current?.getBoundingClientRect()
                        .bottom <=
                    scrollableContainerRef?.current?.getBoundingClientRect()
                        .bottom;
            } else {
                isWindowBelowStartOfContainer =
                    comparisonToControllVisibilityRef.current?.getBoundingClientRect()
                        .bottom <= window.innerHeight;
            }
            setRefreshContentFabButton(isWindowBelowStartOfContainer);
        }
    }, [inView, isScrollingUp, timeoutIsDone]);

    return (
        <>
            <Box ref={ref} />
            <Box ref={comparisonToControllVisibilityRef} />
            {refreshContentFabButton && (
                <FabPositioned
                    hideOnEndOfView={false}
                    position="center-top"
                    isInsideModal={isInsideModal}
                    color={"primary"}
                >
                    <RefreshContentFab
                        onClick={() => {
                            if (scrollableContainerRef) {
                                scrollableContainerRef.current?.scrollTo({
                                    top: 0,
                                    behavior: "smooth",
                                });
                            } else if (scrollToRef) {
                                scrollToRef?.current?.scrollIntoView({
                                    block: "start",
                                    behavior: "smooth",
                                    inline: "nearest",
                                });
                            }
                            onClick();
                        }}
                        disableRipple={true}
                        disableFocusRipple={true}
                        disableTouchRipple={true}
                        withOrangeColorStyles={isPlatformTippspiel}
                    >
                        <ArrowRotateRightIcon
                            color={
                                isPlatformTippspiel
                                    ? "var(--community-color-snow-white)"
                                    : "var(--community-color-primary-text)"
                            }
                            width={"20px"}
                            height={"20px"}
                        />
                        <RefreshContentTypography>
                            aktualisieren
                        </RefreshContentTypography>
                    </RefreshContentFab>
                </FabPositioned>
            )}
        </>
    );
}
